import React, { PropsWithChildren } from 'react';
import SRError from '~/utils/errors/srError';
import { Configuration } from './configuration.type';

const ConfigContext = React.createContext<Configuration | undefined>(undefined);

export const ConfigProvider: React.FC<PropsWithChildren<{ config: Configuration }>> = ({ children, config }) => {
    return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};

export const useConfig = () => {
    const context = React.useContext(ConfigContext);
    if (context === undefined) {
        throw new SRError('useClientConfig must be used within a ClientConfigProvider');
    }

    return context;
};
